import React, { useContext } from 'react'
import { MyContext } from '../App';
import { motion } from "framer-motion"

export default function Hero() {
    const { Lang } = useContext(MyContext);

    const Socials = [
        {
            id: 1,
            title: Lang === 'Ar' ? 'لينكد إن' : 'linkedin',
            url: "https://www.linkedin.com/in/abdelhakimhizmi/",
        },
        {
            id: 2,
            title: Lang === 'Ar' ? 'جيت هاب' : 'github',
            url: "https://github.com/Hakimhizmi",
        },
        {
            id: 3,
            title: Lang === 'Ar' ? 'سولوليرن' : 'Sololearn',
            url: "https://www.sololearn.com/profile/27951557",
        },
        {
            id: 4,
            title: Lang === 'Ar' ? 'إنستغرام' : 'Instagram',
            url: "https://www.instagram.com/hakiim_hizmi/",
        },
    ];

    return (
        <div className="pt-10 px-6 md:px-20 w-screen">
            <motion.h1 initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.3, delay: 0.3 }} className="text-5xl md:text-[8.38vw] font-bold uppercase text-white tracking-wide CosiAzureFont" >
                {Lang === 'Ar' ? 'عبد الحكيم حيزمي' : (Lang === 'Fr' ? 'AbdelHakim HIZMI' : 'AbdelHakim HIZMI')}
            </motion.h1>
            <div className={`flex flex-col md:flex-row justify-between overflow-hidden md:mt-[-1rem] ${Lang === 'Ar' && 'md:mt-[1rem]'}`}>
                <motion.div initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.3, delay: 0.7 }} className="text-lg italic font-medium uppercase text-white/70">
                    {Lang === 'Ar' ? ' مطور ويب متكامل' : (Lang === 'Fr' ? 'Développeur Full Stack' : 'Full Stack Developer')}
                </motion.div>
                <motion.div initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.3, delay: 0.7 }} className="text-lg mr-6 italic font-medium uppercase text-white/70">
                    {Lang === 'Ar' ? 'أكادير، المغرب' : (Lang === 'Fr' ? 'Agadir, Maroc' : 'Agadir, Morocco')}
                </motion.div>
            </div>
            <div className="flex justify-between mt-24 md:mt-[5vw]">
                <div className="flex flex-col gap-4">
                    {Socials.map((social, index) => (
                        <motion.a initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: (1 + index) * 0.3 }} key={social.id} href={social.url} target="_blank" rel="noreferrer" className="text-md font-medium uppercase text-white/70 underline underline-offset-4 hover:text-cyan-600 transition-colors duration-500">
                            {social.title}
                        </motion.a>
                    ))}
                </div>
                
                <motion.div initial={{  scale: 1.1, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 1.5 , delay : 0.3    }}>
                    <a href={Lang === 'Fr' ? "https://drive.google.com/file/d/18fIk7riegaVjfvG6Vx55bjpxS-sgkx75/view?usp=drive_link" : "https://drive.google.com/file/d/17OK9iG12477xiuGtnuDrNaIXcq4a0PGY/view?usp=drive_link"}
                    target="_blank" rel="noreferrer"
                        className="bg-white w-28 h-28 md:w-44 md:h-44 mr-8 md:mr-32 mt-6 rounded-full flex justify-center items-center hover:scale-95 active:scale-90 transition-all duration-400">
                        <div className="uppercase text-lg font-bold italic -rotate-6 text-black/90 text-center">
                            {Lang === 'Ar' ? '!عرض سيرتي الذاتية' : (Lang === 'Fr' ? 'VOIR MON CV!' : 'VIEW MY RESUME!')}
                        </div>
                    </a>
                </motion.div>

            </div>
            <div className="mt-16 mb-8 overflow-hidden">
                <motion.div initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 1.9 }} className="text-sm italic font-medium uppercase text-white/70">
                    {Lang === 'Ar' ? 'حول' : (Lang === 'Fr' ? 'À propos' : 'About')}
                </motion.div>
                <motion.p initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1.7}} className={`text-sm md:text-md italic font-semibold uppercase text-white md:pr-10`}>
                    {Lang === 'Ar' ? 'مرحبًا، أنا حكيم حيزمي، مطور ويب متمكن متخصص في لارافيل/إكسبريس جي إس، رياكت جي إس، رياكت نايتف، تايلويند سي إس، وماي إس كيو إل/مونغو دي بي. أمتلك خبرة واسعة في هذه التقنيات وأستمتع ببناء تطبيقات ويب فعّالة وقوية. مع لارافيل كإطار عمل خلفي أعتمد عليه ورياكت كمكتبة واجهة أمامية، أسعى لتقديم تجارب مستخدم سهلة وسلسة. لدي خبرة في العمل مع قواعد البيانات، خاصة ماي إس كيو إل، لإدارة البيانات بشكل فعّال. أنا متحمس لمتابعة آخر اتجاهات الصناعة واستخدامها في تقديم حلول برمجية عالية الجودة.' :
                        (Lang === 'Fr' ? "Bonjour, je suis Hakim Hizmi, un développeur Full Stack spécialisé dans Laravel/Express Js, React Js, React Native, Tailwind CSS, et MySQL/MongoDB. Je maîtrise parfaitement ces technologies et j'apprécie la création d'applications web robustes et efficaces. Avec Laravel comme mon framework backend de prédilection et React comme ma bibliothèque frontend, je m'efforce de créer des expériences utilisateur fluides. J'ai de l'expérience dans le travail avec les bases de données, en particulier MySQL, pour gérer efficacement les données. Je suis passionné par le fait de rester à jour avec les dernières tendances de l'industrie et de les exploiter pour fournir des solutions logicielles de haute qualité." :
                            "Hi, I'm Hakim Hizmi, a skilled Full stack developer specializing in Laravel/Express Js, React Js, React Native, Tailwind CSS, and MySQL/MongoDB. I have a strong command over these technologies and enjoy building robust and efficient web applications. With Laravel as my go-to backend framework and React as my frontend library, I strive to create seamless user experiences. I'm experienced in working with databases, particularly MySQL, to handle data management effectively. I'm passionate about staying up-to-date with the latest industry trends and leveraging them to deliver high-quality software solutions.")}
                </motion.p>
            </div>
        </div>
    )
}
